<script>
  import ColorPicker from "../../Common/ColorPicker.svelte";
  import {getCollapseClass} from "../../Common/tools";
  import {External, M} from "../../external";

  export let heading,
    data,
    isCollapsable = false,
    isCollapsed = false;

  let textSizeSlider, fontWeightSlider;

  function toggleCollapse() {
    if (isCollapsable) {
      isCollapsed = !isCollapsed;
    }
  }

  $: if(! isCollapsed) {
    External.Tools.addSlider({
      min: 1,
      max: 72,
      step: 1,
      value: data.style.fontSize,
      updatedViewSuffix: 'px',
      element: External.$(textSizeSlider),
      onChange: function (val) {
        data.style.fontSize = val;
      }
    });

    External.Tools.addSlider({
      min: 400,
      max: 700,
      step: 100,
      value: data.style.fontWeight,
      element: External.$(fontWeightSlider),
      onChange: function (val) {
        data.style.fontWeight = val;
      }
    });
  }

</script>

<div class="col20 f-left t-center mt-15" on:click={toggleCollapse}>
  <h4 class="t-left {getCollapseClass(isCollapsable, isCollapsed)}">{heading}</h4>
</div>
{#if !isCollapsed}
  <div class="section">
    <div class="popup-input-wrapper">
      <h5 class="inline">{M.TEXT_FONT_FAMILY}</h5>
      <select bind:value={data.style.fontFamily}>
        {#each External.GlobalStyling.getAvailableFontNames() as font}
          <option value={font}>{font}</option>
        {/each}
      </select>
    </div>
    <div class="popup-input-wrapper input-slider-wrapper">
      <h5 class="inline">{M.FONT_SIZE}</h5>
      <div bind:this={textSizeSlider}></div>
      <input type="text" readonly="readonly" class="slider-val">
    </div>
    <div class="popup-input-wrapper input-slider-wrapper">
      <h5 class="inline">{M.FONT_WEIGHT}</h5>
      <div bind:this={fontWeightSlider}></div>
      <input type="text" readonly="readonly" class="slider-val">
    </div>
    <div class="col20 f-left color-pick-wrap-widgets">
      <ColorPicker bind:color={data.style.color} label={M.FONT_COLOR} alpha="no" />
    </div>
  </div>
{/if}
